import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
    Button,
    Grid,
    Tooltip,
    TextField,
    IconButton,
    InputAdornment,
} from '@material-ui/core';
import { Search } from '@material-ui/icons';
import {
    faFileCsv,
} from '@fortawesome/pro-light-svg-icons';
import { downloadReportAsCsv } from '../../../../store/unawardedShiftlinesReport';
import './UnawardedReportFilters.scss';

function UnawardedReportFilters({ onSearchButtonClick }) {
    const dispatch = useDispatch();
    /** @type {ShiftBidding.ManagerStore} */
    // @ts-ignore
    const { bidProfile } = useSelector((state) => state);
    const { profileId } = bidProfile;

    const [searchString, setSearchString] = useState('');

    const handleDownloadCsv = () => {
        dispatch(downloadReportAsCsv(profileId, searchString));
    };

    return (
        <Grid
            container
            justifyContent="space-between"
            className="report-filter-grid-container unawarded-report-filters-container"
        >
            <Grid
                item
                xs={3}
                lg={3}
                className="report-filter-grid-item"
            >
                <TextField
                    id="react-search-input"
                    size="small"
                    variant="outlined"
                    placeholder="Search"
                    value={searchString}
                    onKeyDown={(e) => (
                        e.key === 'Enter'
                            ? onSearchButtonClick(searchString)
                            : null
                    )}
                    onChange={(e) => setSearchString(e.target.value)}
                    InputProps={{
                        startAdornment: (
                            <InputAdornment
                                position="start"
                            >
                                <Search />
                            </InputAdornment>
                        ),
                    }}
                />
                <Button
                    className="unawarded-report-filters-search-button"
                    variant="contained"
                    onClick={() => onSearchButtonClick(searchString)}
                >
                    Search
                </Button>
            </Grid>

            <Grid
                item
                xs={6}
                lg={6}
                className="report-filter-grid-item align-right"
            >
                <div className="report-filter-button">
                    <Tooltip
                        title="Download to CSV"
                        arrow
                        placement="bottom-end"
                    >
                        <IconButton
                            className="report-filter-csv-button"
                            onClick={handleDownloadCsv}
                        >
                            <FontAwesomeIcon
                                icon={faFileCsv}
                            />
                        </IconButton>
                    </Tooltip>
                </div>

            </Grid>
        </Grid>
    );
}

export default UnawardedReportFilters;
